import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  TextField,
} from "@mui/material";

const ClarityPopup = ({ open, onClose, email }) => {
  const [dateRange, setDateRange] = useState("Last 3 days");

  const projectId = "l12c9owq9b"; // apna actual Clarity project ID

  const encodedEmail = encodeURIComponent(`is;${email}`);
  const encodedDate = encodeURIComponent(dateRange);

  const clarityUrl = `https://clarity.microsoft.com/projects/view/${projectId}/impressions?date=${encodedDate}&CustomUserId=${encodedEmail}`;

  const handleView = () => {
    window.open(clarityUrl, "_blank");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>View Clarity Data</DialogTitle>
      <DialogContent>
        <p>
          <strong>Email:</strong> {email}
        </p>

        <TextField
          select
          label="Date Range"
          value={dateRange}
          onChange={(e) => setDateRange(e.target.value)}
          fullWidth
          margin="dense"
        >
          <MenuItem value="Last 1 day">Last 1 day</MenuItem>
          <MenuItem value="Last 3 days">Last 3 days</MenuItem>
          <MenuItem value="Last 7 days">Last 7 days</MenuItem>
          <MenuItem value="Last 30 days">Last 30 days</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleView} color="primary">
          View in Clarity
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClarityPopup;
